import type { OAuthLicenseAssignment } from "~/server/utils/oauth/oauth.api.utils";

type CompanionLicenseUnlockStateOptions = {
  isSelectedChecklistOutsideTrial: boolean;
  isLoadingLicenses: boolean;
  hasLicenseLoadError: boolean;
  matchingEligibleLicense?: OAuthLicenseAssignment;
  linkedOAuthLicense?: OAuthLicenseAssignment;
  linkedOAuthLicenseMatchesCurriculum: boolean;
  selectedProfileLicenseAssignmentId?: number;
};

const isLicenseUnexpired = (license: OAuthLicenseAssignment) => {
  if (license.status !== "active") return false;
  if (!license.expiration_time) return true;

  return new Date(license.expiration_time).getTime() > Date.now();
};

export const getCompanionLicenseUnlockState = ({
  isSelectedChecklistOutsideTrial,
  isLoadingLicenses,
  hasLicenseLoadError,
  matchingEligibleLicense,
  linkedOAuthLicense,
  linkedOAuthLicenseMatchesCurriculum,
  selectedProfileLicenseAssignmentId,
}: CompanionLicenseUnlockStateOptions) => {
  const canActivateLinkedLicense =
    linkedOAuthLicenseMatchesCurriculum &&
    linkedOAuthLicense != undefined &&
    !isLicenseUnexpired(linkedOAuthLicense) &&
    linkedOAuthLicense.available_to_activate === true;

  const canApplyAvailableLicense =
    !canActivateLinkedLicense &&
    matchingEligibleLicense != undefined &&
    matchingEligibleLicense.id !== selectedProfileLicenseAssignmentId;

  const hasLicenseUnlockAction =
    isSelectedChecklistOutsideTrial &&
    !isLoadingLicenses &&
    !hasLicenseLoadError &&
    (canActivateLinkedLicense || canApplyAvailableLicense);

  return {
    canActivateLinkedLicense,
    canApplyAvailableLicense,
    hasLicenseUnlockAction,
    isPurchaseRequired:
      isSelectedChecklistOutsideTrial &&
      !isLoadingLicenses &&
      !hasLicenseLoadError &&
      !hasLicenseUnlockAction,
  };
};
